console.log('OUAT custom JS loaded stable 💫');

(function () {
  var activeQuickAddButton = null;

  /* ============================
     VARIANT HELPERS
     ============================ */

  function getVariantsFromButton(btn) {
    var raw = btn.getAttribute('data-variants-json');
    if (!raw) return null;

    var jsonString = raw
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    try {
      return JSON.parse(jsonString);
    } catch (e) {
      console.error('Variant JSON parse error:', e, jsonString);
      return null;
    }
  }

  function openVariantModal(variants) {
    var modal = document.getElementById('ouat-variant-modal');
    if (!modal) return;

    var optionsContainer = modal.querySelector('[data-ouat-variant-options]');
    if (!optionsContainer) return;

    optionsContainer.innerHTML = '';

    variants.forEach(function (v) {
      if (!v.available) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ouat-variant-option-btn';
      btn.textContent = v.title;
      btn.setAttribute('data-ouat-variant-choice', v.id);
      optionsContainer.appendChild(btn);
    });

    modal.removeAttribute('hidden');
  }

  function closeVariantModal() {
    var modal = document.getElementById('ouat-variant-modal');
    if (modal) {
      modal.setAttribute('hidden', 'hidden');
    }
    activeQuickAddButton = null;
  }

  /* ============================
     QUICK ADD FUNCTION
     ============================ */

  function quickAddToCart(variantId, originBtn) {
    if (!variantId) {
      console.warn('No variantId passed to quickAddToCart');
      return;
    }

    var productUrl = originBtn
      ? originBtn.getAttribute('data-product-url')
      : null;

    if (originBtn) {
      originBtn.classList.add('ouat-card-btn--loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Network error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        console.log('Added to cart:', data);

        if (originBtn) {
          originBtn.classList.remove('ouat-card-btn--loading');
          originBtn.classList.add('ouat-card-btn--added');

          setTimeout(function () {
            originBtn.classList.remove('ouat-card-btn--added');
          }, 1500);
        }

        // ✨ simplest, always correct: go to cart page
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('Quick add error:', err);
        if (originBtn) {
          originBtn.classList.remove('ouat-card-btn--loading');
        }
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          window.location.href = '/cart';
        }
      });
  }

  /* ============================
     GLOBAL CLICK HANDLER
     ============================ */

  document.addEventListener('click', function (event) {
    // A) Click on quick-add icon on card
    var cardBtn = event.target.closest('.ouat-card-btn--cart');
    if (cardBtn) {
      event.preventDefault();
      console.log('Quick-add clicked:', cardBtn);

      var hasOnlyDefault =
        cardBtn.getAttribute('data-has-only-default') === 'true';
      var firstVariantId = cardBtn.getAttribute('data-variant-id');

      if (hasOnlyDefault) {
        // Single variant (Orchid-style) → quick add
        console.log('Single-variant product, adding directly');
        quickAddToCart(firstVariantId, cardBtn);
      } else {
        // Multi-variant → open variant picker
        console.log('Multi-variant product, opening variant picker');
        var variants = getVariantsFromButton(cardBtn);

        if (!variants || !variants.length) {
          console.warn('No variants parsed, falling back to product page');
          var url = cardBtn.getAttribute('data-product-url');
          if (url) window.location.href = url;
          return;
        }

        activeQuickAddButton = cardBtn;
        openVariantModal(variants);
      }
      return;
    }

    // B) Click on a variant option
    var optionBtn = event.target.closest('[data-ouat-variant-choice]');
    if (optionBtn) {
      var chosenId = optionBtn.getAttribute('data-ouat-variant-choice');
      console.log('Variant chosen from popup:', chosenId);
      if (chosenId) {
        quickAddToCart(chosenId, activeQuickAddButton);
      }
      closeVariantModal();
      return;
    }

    // C) Close modal
    if (
      event.target.closest('.ouat-variant-modal__backdrop') ||
      event.target.closest('.ouat-variant-modal__close')
    ) {
      console.log('Closing variant modal');
      closeVariantModal();
      return;
    }
  });
})();
